import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type AdProgression = google.ima.AdProgressData
type AdControlsType = {
  pause: () => void
  resume: () => void
}

type StoreType = {
  adProgression: AdProgression | null
  adControls: AdControlsType | null
  setAdProgression: (adProgression: AdProgression | null) => void
  setAdControls: (adControls: AdControlsType | null) => void
}

export const useAdsStore = create<StoreType>()(
  devtools(
    immer((set) => ({
      adProgression: null,
      adControls: null,
      setAdProgression: (adProgression) => {
        set(
          (state) => {
            state.adProgression = adProgression
          },
          false,
          'setAdProgression',
        )
      },
      setAdControls: (adControls) => {
        set(
          (state) => {
            state.adControls = adControls
          },
          false,
          'setAdControls',
        )
      },
    })),
    { name: 'AdsStore' },
  ),
)
